
define("json!shoptheme/handles/default.json", function(){ return {
	"default": [
		"shoptheme/components/layout/default",
		"shoptheme/components/layout/page/switch",
	  	"shoptheme/components/layout/page/sidebar-related",
		"shoptheme/components/layout/lazyload",
		"shoptheme/components/layout/messages",
		"shoptheme/components/layout/navigation",
		"shoptheme/components/layout/trigger",
		"shoptheme/components/layout/search",
	  	"shoptheme/components/layout/story",
		"shoptheme/components/layout/equal-heights",
		"shoptheme/components/ui/accordion",
		"shoptheme/components/ui/tabs",
		"shoptheme/components/ui/selects",
		"shoptheme/components/ui/tooltips",
	  	"shoptheme/components/ui/affix",
		"shoptheme/components/ui/affix-generic",
		"shoptheme/components/ui/toggle-visibility",
		"shoptheme/components/ui/scrollspy",
	  	"shoptheme/components/ui/scrolltop",
		"shoptheme/components/ui/generated-menu",
		"shoptheme/components/ui/sections",
		"shoptheme/components/cart/ajax",
		"shoptheme/components/product/wishlist",
		"shoptheme/components/cartware/slider",
		"shoptheme/components/cartware/video",
		"shoptheme/components/customer/terms-of-use-agreement",
		"shoptheme/components/product/compare",
		"shoptheme/components/plugin/universal-analytics",
		"shoptheme/components/blocks/fce/elements/usps",
	  	"shoptheme/components/blocks/fce/elements/image-map",
	    "shoptheme/components/blocks/fce/elements/hero-slider",
		"shoptheme/components/blocks/fce/elements/videoteaser",
	  	"shoptheme/components/blocks/fce/newsletter-subscribe-landingpage",
	  	"shoptheme/components/blocks/csp/detail/firmware-accordion",
		"shoptheme/components/blocks/captcha",
		"shoptheme/components/blocks/privacy/opt",
	  	"shoptheme/components/widgets/band",
		"shoptheme/components/tracking",
		"shoptheme/components/contentbridge/cms-search-results"
	],
	"gigaset_theme_home_index": [
		"shoptheme/components/layout/home"
	],

	"catalog_product_view": [
		"shoptheme/components/product/view",
		"shoptheme/components/product/view/media",
		"shoptheme/components/product/view/specifications",
		"shoptheme/components/product/options",
		"shoptheme/components/review/form",
		"shoptheme/components/product/view/store-ship",
		"shoptheme/components/plugin/shariff",
		"shoptheme/components/plugin/multiline-placeholder",
		"shoptheme/components/review/list"
	],

	"PRODUCT_TYPE_configurable": [
		"cartware/components/magento/product/type/configurable",
		"shoptheme/components/product/type/configurable"
	],

	"catalog_category_layered": [
		"shoptheme/components/category/layered",
		"shoptheme/components/ui/sidebar"
	],

	"newsletter_manage_index": [
		"shoptheme/components/customer/newsletter"
	],

	"customer_account_create": [
		"shoptheme/components/customer/account/create"
	],

	"customer_account_edit": [
		"shoptheme/components/customer/account/edit"
	],

	"gigaset_theme_policy_index": [
		"shoptheme/components/customer/account/policy"
	],

	"gigaset_contentbridge_cms_page": [
		"shoptheme/components/contentbridge/tabs",
		"shoptheme/components/contentbridge/accordeon"
	],

	"gigaset_theme_category_style_elements_1": [
		"shoptheme/components/blocks/elements/product/item/pane"
	],

	"gigaset_csp_support_detail_videotutorials": [
		"shoptheme/components/blocks/fce/elements/videotutorials"
	],

	"checkout_onepage_index": [
		"shoptheme/components/cartware/checkout"
	],

	"gigaset_contentbridge_cms_page_col2-layout-article": [
		"shoptheme/components/ui/anchor-navigation"
	],

	"gigaset_hr_list": [
		"shoptheme/components/ui/datatables"
	],

  	"gigaset_hr_detail": [
		"shoptheme/components/ui/maps"
	],

	"b2e_agreements_popup": [
		"shoptheme/components/customer/b2e/popup"
	]
};});

